import { black500, yellowMain } from '../../../constants/color';
export const SidebarContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'end'
};
export const CustomChip = {
    borderRadius: '25px',
    height: '40px',
    fontSize: '14px',
    color: '#B1B1B1'
};
export const CustomChipDiffColor = {
    borderRadius: '25px',
    height: '40px',
    fontSize: '14px',
    color: '#00000'
};
export const FilterContainer = {
    height: '51px',
    display: 'flex',
    alignItems: 'center',
    borderRadius: '25px',
    gap: 5,
    background: black500,
    padding: '0px 40px'
};
export const JobContainer = {
    padding: '25px',
    borderRadius: '25px',
    background: 'white'
};
export const InfoContainer = {
    width: '100%',
    height: '91px',
    background: yellowMain,
    justifyContent: 'space-between',
    display: 'flex',
    borderRadius: '25px',
    alignItems: 'center',
    padding: '10px'
};
export const descriptionContainer = {
    borderRadius: '25px',
    background: 'white',
    mt: 3
};
export const thankuContainer = {
    height: '553px',
    padding: '25px'
};
export const boxContainer = {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'end',
    height: '100%'
};
export const innerBox = {
    height: '80%',
    width: '493px'
};
